import { createPinia } from 'pinia';

const pinia = createPinia();

export { useSearchStore } from './search';
export { useStructureStore } from './structure';
export { useSectorStore } from './sector';
export { useEmbassyStore } from './embassy';
export { useCardStore } from './cardStore';
export { usePublicPersonalityStore } from './personalityStore';
export { useChatbotStore } from './chatbot';

export default pinia;
